import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ProductsGrid from './components/ProductsGrid';

export default function ProductsPage() {
  const [activeCategory, setActiveCategory] = useState('all');

  const scrollToCategory = (category: string) => {
    setActiveCategory(category);
    const element = document.getElementById(category);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="assets/ProductHero.jpg"
            alt="Cardiovascular Medicine"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-300/20 via-blue-200/10 to-blue-300/20"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-6xl font-bold text-white mb-6 [text-shadow:2px_2px_4px_rgba(0,0,0,1)] text-shadow:-2px_-2px_-4px_rgba(255,255,255,0.9)]">
            Our Pharmaceutical Portfolio
          </h1>
          <p className="text-xl text-white max-w-3xl mx-auto mb-8 [text-shadow:2px_2px_4px_rgba(0,0,0,1)] text-shadow:-2px_-2px_-4px_rgba(255,255,255,0.9)]">
            Comprehensive range of cardiovascular, diabetic, and quality medicines designed for optimal patient care and health outcomes
          </p>
          <div className="flex items-center justify-center gap-8 text-white text-sm">
            <div className="flex items-center gap-2 bg-black/30 px-4 py-2 rounded-lg backdrop-blur-sm">
              <i className="ri-shield-check-line text-2xl text-blue-300"></i>
              <span>ISO 9001:2015 Certified</span>
            </div>
            <div className="flex items-center gap-2 bg-black/30 px-4 py-2 rounded-lg backdrop-blur-sm">
              <i className="ri-hospital-line text-2xl text-blue-300 "></i>
              <span>WHO-GMP Compliant</span>
            </div>
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      {/* <div className="sticky top-16 z-40 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-center gap-2 py-4 overflow-x-auto">
            <button
              onClick={() => scrollToCategory('all')}
              className={`px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === 'all'
                  ? 'bg-gray-900 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className="ri-medicine-bottle-line mr-2"></i>
              All Medicines
            </button>
            <button
              onClick={() => scrollToCategory('cardiovascular')}
              className={`px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === 'cardiovascular'
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
              }`}
            >
              <i className="ri-heart-pulse-line mr-2"></i>
              Cardiovascular
            </button>
            <button
              onClick={() => scrollToCategory('diabetic')}
              className={`px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === 'diabetic'
                  ? 'bg-teal-600 text-white shadow-lg'
                  : 'bg-teal-50 text-teal-700 hover:bg-teal-100'
              }`}
            >
              <i className="ri-syringe-line mr-2"></i>
              Diabetic Care
            </button>
            <button
              onClick={() => scrollToCategory('quality')}
              className={`px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === 'quality'
                  ? 'bg-purple-600 text-white shadow-lg'
                  : 'bg-purple-50 text-purple-700 hover:bg-purple-100'
              }`}
            >
              <i className="ri-capsule-line mr-2"></i>
              Quality Medicines
            </button>
          </div>
        </div>
      </div> */}

      {/* Products Grid */}
      <ProductsGrid activeCategory={activeCategory} />

      <Footer />
    </div>
  );
}
